export enum SubscriptionPlan {
  WebTrial = 'webtrial',
  SalesTrial = 'salestrial',
  Esign = 'esign',
  Professional = 'professional',
  Enterprise = 'enterprise',
  Partner = 'partner',
}
